module.exports = __webpack_public_path__ + "img/widget_expenses.f884199.svg";